const map = new Map();
map.set("a", 2);
map.set("an", 2);
map.set("at", 2);
map.set("are", 2);
map.set("as", 2);
map.set("at", 2);
map.set("and", 2);
map.set("all", 2);
map.set("about", 2);
map.set("after", 2);
map.set("be", 2);
map.set("by", 2);
map.set("but", 2);
map.set("been", 2);
map.set("can", 2);
map.set("could", 2);
map.set("called", 2);
map.set("did", 2);
map.set("down", 2);
map.set("do", 2);
map.set("each", 2);
map.set("from", 2);
map.set("first", 2);
map.set("find", 2);
map.set("for", 2);
map.set("he", 2);
map.set("his", 2);
map.set("had", 2);
map.set("how", 2);
map.set("has", 2);
map.set("her", 2);
map.set("have", 2);
map.set("him", 2);
map.set("in", 2);
map.set("I", 2);
map.set("if", 2);
map.set("into", 2);
map.set("is", 2);
map.set("it", 2);
map.set("its", 2);
map.set("just", 2);
map.set("know", 2);
map.set("like", 2);
map.set("long", 2);
map.set("little", 2);
map.set("my", 2);
map.set("made", 2);
map.set("may", 2);
map.set("make", 2);
map.set("more", 2);
map.set("many", 2);
map.set("most", 2);
map.set("not", 2);
map.set("no", 2);
map.set("now", 2);
map.set("or", 2);
map.set("one", 2);
map.set("of", 2);
map.set("out", 2);
map.set("other", 2);
map.set("over", 2);
map.set("only", 2);
map.set("on", 2);
map.set("people", 2);
map.set("said", 2);
map.set("she", 2);
map.set("some", 2);
map.set("so", 2);
map.set("see", 2);
map.set("the", 2);
map.set("to", 2);
map.set("they", 2);
map.set("this", 2);
map.set("there", 2);
map.set("them", 2);
map.set("then", 2);
map.set("these", 2);
map.set("two", 2);
map.set("time", 2);
map.set("than", 2);
map.set("that", 2);
map.set("their", 2);
map.set("up", 2);
map.set("use", 2);
map.set("very", 2);
map.set("was", 2);
map.set("with", 2);
map.set("what", 2);
map.set("were", 2);
map.set("when", 2);
map.set("we", 2);
map.set("which", 2);
map.set("will", 2);
map.set("would", 2);
map.set("words", 2);
map.set("where", 2);
map.set("water", 2);
map.set("who", 2);
map.set("way", 2);
map.set("you", 2);
map.set("your", 2);
export default map;